module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp1_5012.4fedc6a5.png";